<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label=" Page viii. " class="page" epub:type="pagebreak" id="pviii" role="doc-pagebreak"></span><span aria-label=" Page ix. " class="page" epub:type="pagebreak" id="pix" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocfm"><a class="xref" href="#/chiFischerOA0008#loi">List of Illustrations</a></p>
<p class="toc"><a class="xref" href="#/chiFischerOA0009#intro">Introduction</a></p>
<p class="toc"><a class="xref" href="#/chiFischerOA0010#ch01">1  An Evolving Democracy</a></p>
<p class="toc"><a class="xref" href="#/chiFischerOA0011#ch02">2  An Evolutionary Method of Ethical Deliberation</a></p>
<p class="toc"><a class="xref" href="#/chiFischerOA0012#ch03">3  From Feudalism to Association</a></p>
<p class="toc"><a class="xref" href="#/chiFischerOA0013#ch04">4  The City’s Moral Geology</a></p>
<p class="toc"><a class="xref" href="#/chiFischerOA0014#ch05">5  Educating Immigrants</a></p>
<p class="toc"><a class="xref" href="#/chiFischerOA0015#ch06">6  Science and the Social Settlement</a></p>
<p class="toc"><a class="xref" href="#/chiFischerOA0016#ch07">7  Constructing <i>Democracy and Social Ethics</i></a></p>
<p class="tocbmf"><a class="xref" href="#/chiFischerOA0017#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chiFischerOA0018#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chiFischerOA0020#biblio">Bibliography</a></p>
<p class="tocbm"><a class="xref" href="#/chiFischerOA0021#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Fischer-OA-0007.vue?4d7e7eaa